module.exports = __webpack_public_path__ + "img/no-crust-apple-pie.bb4d58fc.jpg";